/**
 * Question publish-state chip — package `StatusBadge` + status-badge-tints.
 *
 * Ready is the default publish state — showing it on every row is noise. Only
 * Draft is surfaced in cells so authors can spot questions that are not yet
 * live-ready. Filter menus pass `showReady` to keep both options labelled.
 */

import { StatusBadge } from "@exxatdesignux/ui/components/status-badge"
import {
  QUESTION_BANK_STATUS_ICON,
  QUESTION_BANK_STATUS_LABEL,
  QUESTION_BANK_STATUS_TONE,
  normalizeQuestionBankStatus,
  type QuestionBankStatus,
} from "@/lib/question-bank-status"

export function QuestionBankStatusBadge({
  status,
  size = "sm",
  /** When true, also render Ready (filter menus). Cells leave this off. */
  showReady = false,
  className,
}: {
  status: QuestionBankStatus | string | undefined | null
  /** `sm` for tables / filters; `md` for cards and preview. */
  size?: "sm" | "md"
  showReady?: boolean
  className?: string
}) {
  const normalized = normalizeQuestionBankStatus(status)
  if (normalized === "Ready" && !showReady) return null
  // Package gallery: sm = dense table chip (label + tone); md = header/card (+ icon).
  const icon = size === "md" ? QUESTION_BANK_STATUS_ICON[normalized] : undefined
  return (
    <StatusBadge
      label={QUESTION_BANK_STATUS_LABEL[normalized]}
      tone={QUESTION_BANK_STATUS_TONE[normalized]}
      icon={icon}
      size={size}
      className={className}
    />
  )
}
